import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '@shared/shared.module';
import { NgxPayPalModule } from 'ngx-paypal';
import { BankTransferErrorComponent } from './components/card-payment-wrapper/bank-transfer-error/bank-transfer-error.component';
import { BraintreeComponent } from './components/card-payment-wrapper/braintree/braintree.component';
import { CardPaymentWrapperComponent } from './components/card-payment-wrapper/card-payment-wrapper.component';
import { KushkiComponent } from './components/card-payment-wrapper/kushki/kushki.component';
import { NexioComponent } from './components/card-payment-wrapper/nexio/nexio.component';
import { PayPalComponent } from './components/card-payment-wrapper/pay-pal/pay-pal.component';
import { SavedBankTransferComponent } from './components/card-payment-wrapper/saved-bank-transfer/saved-bank-transfer.component';
import { CreateCardPaymentMethodErrorComponent } from './components/create-card-payment-method-error/create-card-payment-method-error.component';
import { SavedCardComponent } from './components/saved-card/saved-card.component';
import { SavedVoucherComponent } from './components/saved-voucher/saved-voucher.component';
import { OxxoVoucherPaymentModalComponent } from './components/voucher-payment-modal/oxxo-voucher-payment-modal/oxxo-voucher-payment-modal.component';

@NgModule({
  declarations: [
    CardPaymentWrapperComponent,
    BraintreeComponent,
    PayPalComponent,
    NexioComponent,
    KushkiComponent,
    SavedCardComponent,
    SavedBankTransferComponent,
    CreateCardPaymentMethodErrorComponent,
    BankTransferErrorComponent,
    OxxoVoucherPaymentModalComponent,
    SavedVoucherComponent,
  ],
  imports: [CommonModule, SharedModule, NgxPayPalModule, FormsModule],
  exports: [
    CardPaymentWrapperComponent,
    SavedCardComponent,
    SavedBankTransferComponent,
    CreateCardPaymentMethodErrorComponent,
    BankTransferErrorComponent,
    OxxoVoucherPaymentModalComponent,
    SavedVoucherComponent,
  ],
})
export class PaymentModule {}
